import { Component, input, output, ViewEncapsulation } from '@angular/core';

/**
 * @deprecated
 * in favor of [`@asn/icon`](https://designsystem.acc.aws.devolksbank.net/index.html?path=/docs/web-components-icon--docs).
 * To be removed with the Angular 23 migration.
 */
/** component for wrapping an icon in a button, with styling and usability. */
@Component({
    selector: 'ap-action-icon',
    templateUrl: './action-icon.component.html',
    styleUrls: ['./action-icon.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class ApActionIconComponent {
    /**
     * Label used for aria-label to help users with a screen reader understand what the button is for
     */
    public readonly ariaLabel = input<string>();

    /**
     * Disable the action icon.
     * Defaults to false
     */
    public readonly isDisabled = input<boolean>(false);

    /** callback for when the button is clicked */
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    public readonly onClick = output<any>();
}
